module.exports = __webpack_public_path__ + "img/ellipse.33bc6dbf.png";